import { 
  createSliceLayout,
  COLOR_WARM_GREY,
  SlicePersonBioGrid,
  SlicePersonBioGridProps,
  PageKnowledgeHubLayout,
  PageKnowledgeHubLayoutProps,
} from '@shapeable/ui';

import { SliceProductBenefits } from '../entities/slice-product-benefits';
import { ProductGrid } from '../entities/product-grid';
import { SliceProductIndustries } from '../entities/slice-product-industries';

export const SliceLayoutBenefits = createSliceLayout(
  SliceProductBenefits
);

export const SliceLayoutProductGrid = createSliceLayout(
  ProductGrid, {
    verticalPadding: 'small',
    boundary: 'content-bleed',
  }
);

export const SliceLayoutPeople = createSliceLayout<SlicePersonBioGridProps>(
  SlicePersonBioGrid, {
    verticalPadding: 'small',
    props: {
      transform: '',
      showEmailContact: true,
    }
  }
); 


export const SliceLayoutProductIndustries = createSliceLayout(
  SliceProductIndustries, {
    verticalPadding: 'small',
    boundary: 'content',
  }
);

export const SliceLayoutKnowledgeHub = createSliceLayout<PageKnowledgeHubLayoutProps>(
  PageKnowledgeHubLayout, {
    boundary: 'content-bleed',
    verticalPadding: 'medium',
    props: {
      filterSize: 'slim',
      filterSpacing: 3,
      showAllTab: true,
      allTabLabel: 'Latest Posts & Insights',
      entityTypes: {
        Post: { latestTitle: 'Latest Posts' },
        FeedEntry: { latestTitle: 'Latest Insights', label: 'All Insights', filterFieldNames: [ "topics" ] }, 
      }
    }
  }
);